export function quotationRequiresApproval(store) {
    return !!(store.getters.getCompany || {}).quotation_requires_approval
}

export function canEmitQuotationPdf(store, note) {
    if (!note || note.status === 'rejected') return false
    if (!quotationRequiresApproval(store)) return true
    return note.status === 'approved' || note.status === 'confirmed'
}

export function canConfirmSalesNote(store, note) {
    if (!note || note.work_order || note.status === 'rejected') return false
    if (!quotationRequiresApproval(store)) return true
    return note.status === 'approved'
}

export function canInternallyApprove(vm, note) {
    if (!quotationRequiresApproval(vm.$store)) return false
    if (!note || note.work_order || note.status !== 'pending') return false
    return vm.$can('approve', 'SalesNote')
}
